import axios from "axios";

// AIS vessels are served by the local Emergent backend (WebSocket proxy to
// AISStream.io), separate from the external SoccorsoGC API.
const BASE =
  process.env.REACT_APP_BACKEND_URL ||
  (typeof window !== "undefined" ? window.location.origin : "");

export async function fetchVessels(bbox) {
  const { data } = await axios.get(`${BASE}/api/ais/vessels`, { params: bbox });
  return data;
}

export async function fetchFlights(params) {
  const { data } = await axios.get(`${BASE}/api/flights`, { params });
  return data;
}
